import {
	Dialog,
	Form,
	FormItem,
	TextInput,
	Toolbar,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export type CreateTemplateNameDialogProps = {
	attachable: IValueInputAttachable<string>;
	isBusy: boolean;
	onClose(): void;
	onSave(): void;
};

export const CreateTemplateNameDialog = (props: CreateTemplateNameDialogProps): ReactElement => {
	const {
		attachable,
		isBusy,
		onClose,
		onSave
	} = props;

	return (
		<Dialog
			trackingId="new-hub-template-name"
			hasBusyIndicator={isBusy}
		>
			<Dialog.Header title={localize("_SaveTemplate")} />
			<Dialog.Body>
				<Form onSubmit={onSave}>
					<FormItem
						isRequired
						label={localize("_Name")}
					>
						<TextInput
							{...attachable.attachToTextInput()}
						/>
						<ValidationError
							{...attachable.attachToValidationError()}
						/>
					</FormItem>
				</Form>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_Save")}
						onClick={onSave}
						trackingId="save"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
						trackingId="cancel"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
CreateTemplateNameDialog.displayName = "CreateTemplateNameDialog";